import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { defaultLeafletLatitude, defaultLeafletLongitude, defaultLeafLetMapZoomValue, LoggedInUserModel, ResponseMessageTypes, RxjsService, SnackbarService } from "@app/shared";
import { IpolyLayersObject } from "@modules/event-management/components/dispatcher-map-view/dispatcher-map-view.component";
import { Control } from 'leaflet';
import "leaflet-draw";
import 'leaflet-routing-machine';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import 'leaflet.markercluster';
declare var L: any;

const PREFIX_IMAGE_RELATIVE_PATH = '../../../../assets/img/dispatcher-map-images/';

enum AlarmCaptionPriority {
    RED = 1, //<Blink>
    BLUE = 2,  // <No blink>
    YELLOW = 3, //<No blink>
    BLACK = 4    // Default value <No blink>
}
@Component({
    selector: "app-event-mgmt-leaf-let-new",
    templateUrl: "./event-mgmt-leaf-let.component.html",
    styleUrls: ["./event-mgmt-leaf-let.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsMgmtSharedLeafLetNewComponent implements OnInit {
    @Input() polyLayersObject: IpolyLayersObject;
    @Input() id = "dispatcher_map_view";
    @Input() caption = "";
    @Input() shouldShowLegend = true;
    @Input() boundaryRequestDetails;
    @Input() zoomInOptions = { latitude: defaultLeafletLatitude, longitude: defaultLeafletLongitude };
    @Input() zoomInOptionsForDispatcherArea = { southWestLatitude: 0, southWestLongitude: 0, northEastLatitude: 0, northEastLongitude: 0 };
    @Input() targetLatLong;
    @Output() onSelection = new EventEmitter();
    @Output() onOpenPopup = new EventEmitter();
    @Output() afterDataRenderedInMapAction = new EventEmitter();
    container;
    map: L.Map;
    drawControl: Control;
    openedPopup: L.Popup;
    selectedLayer;
    loggedInUserData: LoggedInUserModel;
    encodedToken = "";
    editablePolygonLayers = new L.FeatureGroup();
    editableMarkerVehicleLayers = new L.FeatureGroup();
    editableMarkerSiteLayers = new L.FeatureGroup();
    currentLocationAndDestinationMarkerSiteLayers = new L.FeatureGroup();
    editablePolyLineLayers = new L.FeatureGroup();
    routingPathControl;
    sourceLatLong: L.LatLng;

    constructor(private rxjsService: RxjsService, private snackbarService: SnackbarService) {
        this.rxjsService.setGlobalLoaderProperty(true);
    }

    ngOnInit(): void {
        requestAnimationFrame(() => {
            // Check if map already exists then remove after that recreate the map
            if (this.map) {
                this.map.remove();
            }
            // Create a container using element's id
            this.container = document.getElementById(this.id);
            // create a map using created element's container using default options like zoom and lat,long values
            this.map = L.map(this.container).setView(
                [this.zoomInOptions.latitude, this.zoomInOptions.longitude],
                defaultLeafLetMapZoomValue
            );
            // normal view layer
            let customPaidTileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').
                addTo(this.map);
            // Satellite view layer based on google's open API
            let googleSatelliteViewTileLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });
            let baseMaps: L.Control.LayersObject = {
                "Normal View": customPaidTileLayer,
                "Satellite View": googleSatelliteViewTileLayer
            };
            L.control.layers(baseMaps, null, { position: 'bottomleft' }).addTo(this.map);
            if (this.caption == 'Third Party Map View') {
                this.trackTheCurrentSourceMovingLocation();
                this.map.addLayer(this.currentLocationAndDestinationMarkerSiteLayers);
            }
            // Select default view as custom paid layer
            customPaidTileLayer.addTo(this.map);
        });
    }

    ngAfterViewInit() {
        requestAnimationFrame(() => {
            this.map.addLayer(this.editableMarkerVehicleLayers);
            this.map.addLayer(this.editableMarkerSiteLayers);
            this.map.addLayer(this.editablePolygonLayers);
            this.map.addLayer(this.editablePolyLineLayers);
            // Create and Add draw control to leaflet map
            this.drawControl = new L.Control.Draw({
                draw: {
                    circle: false,
                    circlemarker: false,
                    marker: false,
                    polygon: false,
                    polyline: false,
                    rectangle: false
                }
            });
            this.map.addControl(this.drawControl);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (let prop in changes) {
            switch (prop) {
                case 'polyLayersObject':
                    if (this.map) {
                        if (this.polyLayersObject) {
                            if (this.polyLayersObject.isUpdatedLayers == true) {
                                //this.editablePolygonLayers.clearLayers();
                            }
                            if (this.polyLayersObject.isUpdatedResponseOfficers == true) {
                                //this.editableMarkerVehicleLayers.clearLayers();
                            }
                            if (this.polyLayersObject.isUpdatedCustomerAddress == true) {
                                //this.editableMarkerSiteLayers.clearLayers();
                            }
                            if (this.polyLayersObject.isUpdatedRoots == true) {
                                // this.editablePolyLineLayers.eachLayer((layer) => {
                                // 	this.editablePolyLineLayers.removeLayer(layer);
                                // });
                                //this.editablePolyLineLayers.clearLayers();
                            }
                            this.prepareDrawableShapes();
                        }
                    }
                    break;
                case "zoomInOptions":
                    // zoom in leaf let map based on lat,long filter
                    if (this.map) {
                        var southWest = new L.LatLng(this.zoomInOptions.latitude, this.zoomInOptions.longitude),
                            northEast = new L.LatLng(this.zoomInOptions.latitude, this.zoomInOptions.longitude),
                            bounds = new L.LatLngBounds(southWest, northEast);
                        this.map.fitBounds(bounds);
                    }
                    break;
                case "zoomInOptionsForDispatcherArea":
                    if (this.map && this.zoomInOptionsForDispatcherArea.southWestLatitude && this.zoomInOptionsForDispatcherArea.southWestLatitude !== 0) {
                        var southWest = new L.LatLng(this.zoomInOptionsForDispatcherArea.southWestLatitude, this.zoomInOptionsForDispatcherArea.southWestLongitude),
                            northEast = new L.LatLng(this.zoomInOptionsForDispatcherArea.northEastLatitude, this.zoomInOptionsForDispatcherArea.northEastLongitude),
                            bounds = new L.LatLngBounds(southWest, northEast);
                        this.map.fitBounds(bounds);
                    }
                    break;
                case "targetLatLong":
                    if (this.caption == 'Third Party Map View') {
                        this.currentLocationAndDestinationMarkerSiteLayers.clearLayers();
                        if (this.targetLatLong.latitude && this.targetLatLong.longitude) {
                            this.trackTheCurrentSourceMovingLocation();
                        }
                    }
                    break;
            }
        }
    }

    logCurrentShapeCounts() {
        const counts = {
            polygons: this.editablePolygonLayers.getLayers().length,
            vehicleMarkers: this.editableMarkerVehicleLayers.getLayers().length,
            siteMarkers: this.editableMarkerSiteLayers.getLayers().length,
            polylines: this.editablePolyLineLayers.getLayers().length,
            routingMarkers: this.currentLocationAndDestinationMarkerSiteLayers.getLayers().length
        };
        console.log('Current shape counts:', counts);
        return counts;
    }

    trackTheCurrentSourceMovingLocation() {
        this.map.locate().on('locationfound', (e) => {
            this.sourceLatLong = e.latlng;
            this.trackTheTargetMovingLocation();
        }).on('locationerror', (e) => {
            this.snackbarService.openSnackbar("Location access is denied", ResponseMessageTypes.WARNING);
        });
    }

    createIcon(iconName: string): L.Icon {
        return new L.Icon({ iconUrl: `${PREFIX_IMAGE_RELATIVE_PATH}${iconName}` });
    }

    trackTheTargetMovingLocation() {
        //source marker
        let sourceMarker = L.marker(this.sourceLatLong,
            { icon: this.createIcon("vehicle-dispatched.png") });
        this.currentLocationAndDestinationMarkerSiteLayers.addLayer(sourceMarker);
        if (this.targetLatLong.targetInitialLatitude && this.targetLatLong.targetInitialLongitude) {
            // initial target marker
            let targetInitialMarker = L.marker([this.targetLatLong.targetInitialLatitude, this.targetLatLong.targetInitialLongitude],
                { icon: this.createIcon("site-panic-initial.png") }).bindTooltip("Panic signal where triggered initially..!!");
            this.currentLocationAndDestinationMarkerSiteLayers.addLayer(targetInitialMarker);
            // current target marker
            let currentTargetMarker = L.marker([this.targetLatLong.latitude, this.targetLatLong.longitude],
                { icon: this.createIcon("site-panic-follow.png") });
            this.currentLocationAndDestinationMarkerSiteLayers.addLayer(currentTargetMarker);
            let endingPoint = new L.LatLng(this.targetLatLong.latitude, this.targetLatLong.longitude);
            let latlngs = [this.sourceLatLong, endingPoint];
            let polyLine = new L.Polyline(latlngs, {
                color: '#115943',
                weight: 3
            });
            this.currentLocationAndDestinationMarkerSiteLayers.addLayer(polyLine);
            this.afterDataRenderedInMapAction.emit(true);
        }
    }

    polygonLayerMap: Map<string, L.Layer> = new Map();
    vehicleLayerMap: Map<string, L.Marker> = new Map();
    siteLayerMap: Map<string, L.Marker> = new Map();
    polylineLayerMap: Map<string, L.Polyline> = new Map();

    // draw shapes like polygons, points( such as vehicles, sites ), polylines etc
    // private prepareDrawableShapes(): void {
    //   if (!this.polyLayersObject?.polyLayers?.length) return;

    //   const layers = [...this.polyLayersObject.polyLayers];
    //   const chunkSize = 50;

    //   const processChunk = () => {
    //     let count = 0;

    //     while (layers.length && count < chunkSize) {
    //       const layer = layers.shift();
    //       if (!layer) continue;

    //       const props = layer.feature?.properties || layer.options;
    //       const shapeType = props.shapeType;
    //       const id = props.id;

    //       if (shapeType === 'Polygon') {
    //         const existing = this.polygonLayerMap.get(id);
    //         if (existing) {
    //           if (!this.isSamePolygon(existing, layer)) {
    //             this.editablePolygonLayers.removeLayer(existing);
    //             this.polygonLayerMap.delete(id);
    //             this.addPolygonLayer(layer, id, props);
    //           }
    //         } else {
    //           this.addPolygonLayer(layer, id, props);
    //         }
    //       }

    //       else if (shapeType === 'Point') {
    //         const map = props.legentType === 'Vehicle' ? this.vehicleLayerMap : this.siteLayerMap;
    //         const layerGroup = props.legentType === 'Vehicle' ? this.editableMarkerVehicleLayers : this.editableMarkerSiteLayers;
    //         const existing = map.get(id);
    //         if (existing) {
    //           if (!this.isSameMarker(existing, props)) {
    //             layerGroup.removeLayer(existing);
    //             map.delete(id);
    //             this.addPointLayer(props, map, layerGroup, id);
    //           }
    //         } else {
    //           this.addPointLayer(props, map, layerGroup, id);
    //         }
    //       }

    //       else if (shapeType === 'LineString') {
    //         const existing = this.polylineLayerMap.get(id);
    //         if (existing) {
    //           if (!this.isSamePolyline(existing, props)) {
    //             this.editablePolyLineLayers.removeLayer(existing);
    //             this.polylineLayerMap.delete(id);
    //             this.addPolylineLayer(props, id);
    //           }
    //         } else {
    //           this.addPolylineLayer(props, id);
    //         }
    //       }

    //       count++;
    //     }

    //     if (layers.length) {
    //       requestAnimationFrame(processChunk);
    //     } else {
    //       this.afterDataRenderedInMapAction.emit(true);
    //     }
    //   };

    //   requestAnimationFrame(processChunk);
    // }

    // draw shapes like polygons, points( such as vehicles, sites ), polylines etc
    // private prepareDrawableShapes(): void {
    //   if (!this.polyLayersObject?.polyLayers?.length) return;

    //   const layers = [...this.polyLayersObject.polyLayers];
    //   const chunkSize = 200;

    //   const processChunk = () => {
    //     let count = 0;

    //     while (layers.length && count < chunkSize) {
    //       const layer = layers.shift();
    //       if (!layer) continue;

    //       const props = layer.feature?.properties || layer.options;
    //       const shapeType = props.shapeType;
    //       const id = props.id;

    //       if (shapeType === 'Polygon') {
    //         const existing = this.polygonLayerMap.get(id);
    //         if (existing) {
    //           if (!this.isSamePolygon(existing, layer)) {
    //             this.editablePolygonLayers.removeLayer(existing);
    //             this.polygonLayerMap.delete(id);
    //             this.addPolygonLayer(layer, id, props);
    //           }
    //         } else {
    //           this.addPolygonLayer(layer, id, props);
    //         }
    //       }

    //       else if (shapeType === 'Point') {
    //         const map = props.legentType === 'Vehicle' ? this.vehicleLayerMap : this.siteLayerMap;
    //         const layerGroup = props.legentType === 'Vehicle' ? this.editableMarkerVehicleLayers : this.editableMarkerSiteLayers;
    //         const existing = map.get(id);
    //         if (existing) {
    //           if (!this.isSameMarker(existing, props)) {
    //             layerGroup.removeLayer(existing);
    //             map.delete(id);
    //             this.addPointLayer(props, map, layerGroup, id);
    //           }
    //         } else {
    //           this.addPointLayer(props, map, layerGroup, id);
    //         }
    //       }

    //       else if (shapeType === 'LineString') {
    //         const existing = this.polylineLayerMap.get(id);
    //         if (existing) {
    //           if (!this.isSamePolyline(existing, props)) {
    //             this.editablePolyLineLayers.removeLayer(existing);
    //             this.polylineLayerMap.delete(id);
    //             this.addPolylineLayer(props, id);
    //           }
    //         } else {
    //           this.addPolylineLayer(props, id);
    //         }
    //       }

    //       count++;
    //     }

    //     if (layers.length) {
    //       requestAnimationFrame(processChunk);
    //     } else {
    //       this.afterDataRenderedInMapAction.emit(true);
    //     }
    //   };

    //   requestAnimationFrame(processChunk);
    // }

   prepareDrawableShapes() {
    if (!this.polyLayersObject?.polyLayers?.length) return;

    const currentPolygonIds = new Set<string>();
    const currentVehicleIds = new Set<string>();
    const currentSiteIds = new Set<string>();
    const currentPolylineIds = new Set<string>();

    this.polyLayersObject.polyLayers.forEach((layer, index) => {
        const props = layer.feature?.properties || layer.options;
        const shapeType = props.shapeType;
        const id = props.id;

        if (!id) return; // skip if ID is not available

        if (shapeType === 'Polygon') {
            //currentPolygonIds.add(id);
            const existing = this.polygonLayerMap.get(id);
            if (existing) {
                if (!this.isSamePolygon(existing, layer)) {
                    this.editablePolygonLayers.removeLayer(existing);
                    this.polygonLayerMap.delete(id);
                    this.addPolygonLayer(layer, id, props);
                }
            } else {
                this.addPolygonLayer(layer, id, props);
            }
        } else if (shapeType === 'Point') {
            const isVehicle = props.legentType === 'Vehicle';
            const map = isVehicle ? this.vehicleLayerMap : this.siteLayerMap;
            const layerGroup = isVehicle ? this.editableMarkerVehicleLayers : this.editableMarkerSiteLayers;

            if (isVehicle) currentVehicleIds.add(id);
            else currentSiteIds.add(id);

            const existing = map.get(id);
            if (existing) {
                if (!this.isSameMarker(existing, props)) {
                    layerGroup.removeLayer(existing);
                    map.delete(id);
                    this.addPointLayer(props, map, layerGroup, id);
                }
            } else {
                this.addPointLayer(props, map, layerGroup, id);
            }
        } else if (shapeType === 'LineString') {
            currentPolylineIds.add(id);
            const existing = this.polylineLayerMap.get(id);
            if (existing) {
                if (!this.isSamePolyline(existing, props)) {
                    this.editablePolyLineLayers.removeLayer(existing);
                    this.polylineLayerMap.delete(id);
                    this.addPolylineLayer(props, id);
                }
            } else {
                this.addPolylineLayer(props, id);
            }
        }

        if (index === this.polyLayersObject.polyLayers.length - 1) {
            //this.logCurrentShapeCounts();
        }
    });

    // Clean up: Remove deleted Polygon layers
    // this.polygonLayerMap.forEach((layer, id) => {
    //     if (!currentPolygonIds.has(id)) {
    //         this.editablePolygonLayers.removeLayer(layer);
    //         this.polygonLayerMap.delete(id);
    //     }
    // });

    // Clean up: Remove deleted Vehicle markers
    this.vehicleLayerMap.forEach((layer, id) => {
        if (!currentVehicleIds.has(id)) {
            this.editableMarkerVehicleLayers.removeLayer(layer);
            this.vehicleLayerMap.delete(id);
        }
    });

    // Clean up: Remove deleted Site markers
    this.siteLayerMap.forEach((layer, id) => {
        if (!currentSiteIds.has(id)) {
            this.editableMarkerSiteLayers.removeLayer(layer);
            this.siteLayerMap.delete(id);
        }
    });

    // Clean up: Remove deleted Polylines
    this.polylineLayerMap.forEach((layer, id) => {
        if (!currentPolylineIds.has(id)) {
            this.editablePolyLineLayers.removeLayer(layer);
            this.polylineLayerMap.delete(id);
        }
    });

    this.afterDataRenderedInMapAction.emit(true);
}

    cleanupLayers() {
        this.editablePolygonLayers.clearLayers();
        this.editableMarkerVehicleLayers.clearLayers();
        this.editableMarkerSiteLayers.clearLayers();
        this.currentLocationAndDestinationMarkerSiteLayers.clearLayers();
        this.editablePolyLineLayers.clearLayers();
        this.polygonLayerMap.clear();
        this.vehicleLayerMap.clear();
        this.siteLayerMap.clear();
        this.polylineLayerMap.clear();
    }

    addPolygonLayer(layer: L.Layer, id: string, props: any) {
        this.setupPolygonEvents(layer, props);
        this.editablePolygonLayers.addLayer(layer);
        this.polygonLayerMap.set(id, layer);
    }

    setupPolygonEvents(layer: L.Layer, props: any) {
        const tooltip = props.displayName;
        if (tooltip && this.polyLayersObject?.isShowLayerLabelName) {
            layer.bindTooltip(tooltip, {
                permanent: true,
                direction: "center",
                // zoomAnimation: true,
                className: 'toolTipTransparentColor'
            }).openTooltip();
        }

        const overStyle = { weight: 6, fillOpacity: 0.3 };
        const outStyle = { weight: 3, fillOpacity: props.fillOpacity };

        layer.on('mouseover', (e) => (layer as L.Path).setStyle(overStyle));
        layer.on('mouseout', (e) => (layer as L.Path).setStyle(outStyle));
        layer.on('click', (e) => {
            this.openedPopup = L.popup()
                .setLatLng(e.latlng)
                .setContent(`<strong>Area Name : ${props.displayName}</strong>`)
                .openOn(this.map);
        });

        (layer as L.Path).setStyle({
            color: props.color,
            fillColor: props.fillColor,
            fillOpacity: props.fillOpacity,
            weight: props.weight
        });
    }

    addPointLayer(props: any, map: Map<string, L.Marker>, group: L.LayerGroup, id: string) {
        const marker = L.marker(props.coordinates, {
            icon: new L.Icon({ iconUrl: `${PREFIX_IMAGE_RELATIVE_PATH}${props.iconName}` })
        });

        this.setupMarkerEvents(marker, props);
        group.addLayer(marker);
        map.set(id, marker);
    }

    setupMarkerEvents(marker: L.Marker, props: any) {
        if (props.displayText) {
            const className = ['RED', 'BLUE', 'YELLOW'].includes(props.alarmCaptionPriority)
                ? "toolTipBackgroundWhiteWithDisplayColor"
                : "toolTipBackgroundWhiteWithoutDisplayColor";
            marker.bindTooltip(props.displayText, {
                permanent: true,
                direction: "right",
                // zoomAnimation: true,
                className
            }).openTooltip();
        }

        marker.on('click', () => this.onOpenPopup.emit(props));

        marker.on('mouseover', (e) => {
            const popupHtml = props.legentType === 'Site'
                ? `<strong>Customer Name: ${props.displayName}</strong><br>
         <strong>Address: ${props.fullAddress || '-'}</strong><br>
         <strong>Mobile: ${props.mobileNumber || '-'}</strong>`
                : `<strong>Response Officer: ${props.displayName}</strong><br>
         <strong>Sub Area: ${props.subArea || '-'}</strong><br>
         <strong>Vehicle Reg: ${props.vehicleRegistrationNumber || '-'}</strong><br>
         <strong>Coordinates: ${props.coordinates || '-'}</strong>`;
            this.openedPopup = L.popup().setLatLng(e.latlng).setContent(popupHtml).openOn(this.map);
        });

        marker.on('mouseout', () => {
            requestAnimationFrame(() => this.map.closePopup(this.openedPopup));
        });
    }

    addPolylineLayer(props: any, id: string) {
        const coords = [
            new L.LatLng(props.coordinates[0][0], props.coordinates[0][1]),
            new L.LatLng(props.coordinates[1][0], props.coordinates[1][1])
        ];
        const polyline = new L.Polyline(coords, {
            color: props.color || 'orange',
            weight: 3
        });

        this.setupPolylineEvents(polyline, props);
        this.editablePolyLineLayers.addLayer(polyline);
        this.polylineLayerMap.set(id, polyline);
    }

    setupPolylineEvents(polyline: L.Polyline, props: any) {
        polyline.on('mouseover', (e) => polyline.setStyle({ weight: 6 }));
        polyline.on('mouseout', (e) => polyline.setStyle({ weight: 3 }));
    }

    isSamePolygon(oldLayer: any, newLayer: any): boolean {
        // Compare options, coordinates, color etc.
        return JSON.stringify(oldLayer.feature.properties) === JSON.stringify(newLayer.feature.properties);
    }

    isSameMarker(oldMarker: L.Marker, newProps: any): boolean {
        // Compare coordinates and icon URL
        const oldCoords = oldMarker.getLatLng();
        return oldCoords.lat === newProps.coordinates[0] && oldCoords.lng === newProps.coordinates[1];
    }

    isSamePolyline(oldPolyline: L.Polyline, newProps: any): boolean {
        const latlngs = oldPolyline.getLatLngs() as L.LatLng[];
        return latlngs[0].lat === newProps.coordinates[0][0] &&
            latlngs[0].lng === newProps.coordinates[0][1] &&
            latlngs[1].lat === newProps.coordinates[1][0] &&
            latlngs[1].lng === newProps.coordinates[1][1];
    }

    ngOnDestroy(): void {
        if (this.map) {
            this.map.off(); // remove all event handlers
            this.map.remove(); // destroy map instance
            this.cleanupLayers();
        }
    }

}